export enum ContactType {
    None = 0 ,
    Configured = 1,
    Manual = 2,
}
